// import React from 'react';

export interface ICountryRedirectPopupProps {
	classNames?: string;
}

export const POPUP_COOKIE_NAME = 'countryRedirectPopup';
